<template>
  <div class="overflow-hidden primary-background min-100-vh">
    <v-sheet min-height="270" elevation="5" class="d-flex justify-center align-end pb-12 position-relative" color="white" relative>
      <v-container>
        <v-img 
        alt="Vuetify Logo"
        class="shrink mx-auto"
        contain
        src="../../assets/logo.png"
        transition="scale-transition"
        width="150"></v-img>
      </v-container>
      <div class="right-bar"></div>
    </v-sheet>
    <v-sheet class="white--text transparent">
      <v-container>
        <h1 class="display-2 mt-3 font-weight-black mb-2">Welcome Back</h1>
        <p>Please Login to continue</p>
        <v-form @submit.prevent="signin(data)">

        <v-row >
          <v-col cols="12" sm="6" lg="5">
            <v-text-field dark type="email" label="Email" v-model="data.email"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" lg="5">
            <v-text-field label="Password" v-model="data.password" type="password" dark></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" lg="2" class="text-center">
            <v-btn :loading="loader" block class="primary-color mb-4 font-weight-bold" type="submit" elevation="10" height="50">
              Login
            </v-btn>
          </v-col>
        </v-row>
        </v-form>

      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters , mapActions } from 'vuex'
export default {
  name : 'Login',
  data (){
    return {
      data : {
        email : '',
        password : '',
      }
     }
  },
  mounted () {
      if (localStorage.getItem("user")) {
        this.$router.push({
          name: "Home",
        })
      }
  },
  computed : {
    ...mapGetters({
      loader : 'Global/loader'
    })
  },
  methods : {
    ...mapActions({
      'signin' : 'Auth/signin'
    })
  }
}
</script>

<style scoped>
.right-bar {
  position : absolute;
  right: 0;
  top: 50%;
  transform : translateY(-50%);
  width: 10px;
  height : 100px;
  background : var(--primary-color);
  opacity: 0.3;
}
</style>